export default __webpack_public_path__ + "static/media/loadinfo.4ace5f17.gif";